<template>
    <div class="container-fluid wrapper">
        <loader :loader="isLoading" v-if="isLoading" />
        <div>
            <div class="header row justify-content-between align-items-center">
                <div class="mt-2 col-10" style="padding-left: 40px">
                    <p class="title mb-1">{{ $t('moodPulse.moodPulse') }}</p>
                    <p class="text">{{ $t('moodPulse.description') }}</p>
                </div>
                <div class="col-2 pl-5 pr-0">
                    <button id="btn-humor-new-survey" @click="toggleNewQuiz" centered class="btn btn-primary">
                        {{ $t('moodPulse.btnNew') }}
                    </button>
                </div>
            </div>
            <div v-if="items.length || pausedItems.length">
                <div class="container-fluid p-5">
                    <b-table
                        v-if="items.length"
                        head-variant="light"
                        hover
                        :items="items"
                        :fields="fields"
                        :thead-class="headerClass"
                    >
                        <template #cell(title)="data">
                            <div
                                style="width: 400px"
                                @click="
                                    $router.push(`/v2/administrator/mood-pulse/report/${data.item.quiz_question[0].id}`)
                                "
                                class="body-class"
                                v-if="data.item.quiz_status_id === quizStatus.onGoing.id"
                            >
                                <span style="text-decoration: underline; cursor: pointer">
                                    {{ data.item.quiz_question[0].question }}
                                </span>
                                <img src="../../../src/assets/images/mood-pulse/line-chart.svg" />
                            </div>
                            <div style="width: 400px" class="body-class" v-else>
                                {{ data.item.quiz_question[0].question }}
                            </div>
                        </template>

                        <template #cell(week)="data">
                            <div style="margin-left: 4%" class="body-class">
                                <span style="margin-right: 3px" v-if="data.item.sunday">
                                    {{ $t('moodPulse.sundayInitial') }}
                                </span>
                                <span style="margin-right: 3px" v-if="data.item.monday">
                                    {{ $t('moodPulse.mondayInitial') }}
                                </span>
                                <span style="margin-right: 3px" v-if="data.item.tuesday">
                                    {{ $t('moodPulse.tuesdayInitial') }}
                                </span>
                                <span style="margin-right: 3px" v-if="data.item.wednesday">
                                    {{ $t('moodPulse.wednesdayInitial') }}
                                </span>
                                <span style="margin-right: 3px" v-if="data.item.thursday">
                                    {{ $t('moodPulse.thursdayInitial') }}
                                </span>
                                <span style="margin-right: 3px" v-if="data.item.friday">
                                    {{ $t('moodPulse.fridayInitial') }}
                                </span>
                                <span style="margin-right: 3px" v-if="data.item.saturday">
                                    {{ $t('moodPulse.saturdayInitial') }}
                                </span>
                            </div>
                        </template>

                        <template #cell(status)="data">
                            <div class="mt-2">
                                <b-button
                                    v-if="data.item.quiz_status_id === quizStatus.onGoing.id"
                                    size="sm"
                                    variant="primary"
                                    class="status-btn"
                                    style="pointer-events: none; background-color: #66c2e9; border-color: #66c2e9"
                                >
                                    {{ quizStatus.onGoing.value }}
                                </b-button>
                                <b-button
                                    v-if="data.item.quiz_status_id === quizStatus.notStarted.id"
                                    size="sm"
                                    variant="outline-primary"
                                    class="status-btn"
                                    style="pointer-events: none; color: #66c2e9; border-color: #66c2e9"
                                >
                                    {{ quizStatus.notStarted.value }}
                                </b-button>
                            </div>
                        </template>

                        <template #cell(actions)="data">
                            <div class="mt-2">
                                <b-button
                                    v-if="data.item.quiz_status_id === quizStatus.onGoing.id"
                                    id="btn-humor-pause-survey"
                                    variant="outline-primary"
                                    size="sm"
                                    class="action-btn"
                                    @click="
                                        showPauseQuiz = true
                                        selectedItem = data.item
                                    "
                                >
                                    {{ $t('moodPulse.btnPause') }}
                                </b-button>
                                <b-button
                                    v-if="data.item.quiz_status_id === quizStatus.notStarted.id"
                                    id="btn-humor-start-survey-again"
                                    variant="primary"
                                    size="sm"
                                    class="action-btn"
                                    @click="changeQuizStatus(data.item, quizStatus.onGoing.id)"
                                >
                                    {{ $t('moodPulse.btnStart') }}
                                </b-button>
                            </div>
                        </template>

                        <template #cell(edit)="data">
                            <div class="mt-2">
                                <b-dropdown dropleft no-caret size="sm" variant="white" class="ml-2">
                                    <template slot="button-content">
                                        <i style="color: #009bdb !important" class="fas fa-ellipsis-v text-muted" />
                                    </template>
                                    <b-dropdown-item
                                        v-if="!data.item.cardEditDelete"
                                        id="btn-humor-edit-survey"
                                        @click="
                                            () => {
                                                toggleNewQuiz()
                                                currentQuiz = data.item
                                            }
                                        "
                                        >{{ $t('form.button.edit') }}</b-dropdown-item
                                    >
                                    <b-dropdown-item
                                        id="btn-humor-delete-survey"
                                        @click="
                                            () => {
                                                toggleDeleteQuiz()
                                                currentQuiz = data.item
                                            }
                                        "
                                        >{{ $t('form.button.delete') }}</b-dropdown-item
                                    >
                                </b-dropdown>
                            </div>
                        </template>
                    </b-table>
                    <b-table
                        v-if="pausedItems.length"
                        head-variant="light"
                        hover
                        :items="pausedItems"
                        :fields="pausedFields"
                        :thead-class="headerClass"
                        table-class="border-radius: 9px"
                    >
                        <template #head(week)>
                            <div style="width: 85px" />
                        </template>

                        <template #cell(title)="data">
                            <div
                                @click="
                                    $router.push(`/v2/administrator/mood-pulse/report/${data.item.quiz_question[0].id}`)
                                "
                                style="width: 396px"
                                class="body-class"
                            >
                                <span style="text-decoration: underline; cursor: pointer">
                                    {{ data.item.quiz_question[0].question }}
                                </span>
                                <img src="../../../src/assets/images/mood-pulse/line-chart.svg" />
                            </div>
                        </template>

                        <template #cell(weeks)="data">
                            <div style="margin-left: 4%" class="body-class">
                                <span style="margin-right: 3px" v-if="data.item.sunday">
                                    {{ $t('moodPulse.sundayInitial') }}
                                </span>
                                <span style="margin-right: 3px" v-if="data.item.monday">
                                    {{ $t('moodPulse.mondayInitial') }}
                                </span>
                                <span style="margin-right: 3px" v-if="data.item.tuesday">
                                    {{ $t('moodPulse.tuesdayInitial') }}
                                </span>
                                <span style="margin-right: 3px" v-if="data.item.wednesday">
                                    {{ $t('moodPulse.wednesdayInitial') }}
                                </span>
                                <span style="margin-right: 3px" v-if="data.item.thursday">
                                    {{ $t('moodPulse.thursdayInitial') }}
                                </span>
                                <span style="margin-right: 3px" v-if="data.item.friday">
                                    {{ $t('moodPulse.fridayInitial') }}
                                </span>
                                <span style="margin-right: 3px" v-if="data.item.saturday">
                                    {{ $t('moodPulse.saturdayInitial') }}
                                </span>
                            </div>
                        </template>

                        <template #cell(status)="data">
                            <div class="mt-2">
                                <b-button
                                    v-if="data.item.quiz_status_id === quizStatus.paused.id"
                                    size="sm"
                                    variant="danger"
                                    class="status-btn"
                                    style="pointer-events: none; background-color: #eb9d9d; border-color: #eb9d9d"
                                >
                                    {{ quizStatus.paused.value }}
                                </b-button>
                            </div>
                        </template>

                        <template #cell(actions)="data">
                            <div class="mt-2">
                                <b-button
                                    v-if="data.item.quiz_status_id === quizStatus.paused.id"
                                    variant="outline-primary"
                                    size="sm"
                                    class="action-btn"
                                    @click="changeQuizStatus(data.item, quizStatus.onGoing.id)"
                                >
                                    {{ $t('moodPulse.btnRetake') }}
                                </b-button>
                            </div>
                        </template>

                        <template #cell(edit)="data">
                            <div class="mt-2">
                                <b-dropdown dropleft no-caret size="sm" variant="white" class="ml-2">
                                    <template slot="button-content">
                                        <i style="color: #009bdb !important" class="fas fa-ellipsis-v text-muted" />
                                    </template>
                                    <b-dropdown-item
                                        v-if="!data.item.cardEditDelete"
                                        @click="
                                            () => {
                                                toggleNewQuiz()
                                                currentQuiz = data.item
                                            }
                                        "
                                        >{{ $t('form.button.edit') }}</b-dropdown-item
                                    >
                                    <b-dropdown-item
                                        @click="
                                            () => {
                                                toggleDeleteQuiz()
                                                currentQuiz = data.item
                                            }
                                        "
                                        >{{ $t('form.button.delete') }}</b-dropdown-item
                                    >
                                </b-dropdown>
                            </div>
                        </template>
                    </b-table>
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="pageTotal"
                        per-page="5"
                        @input="updateItems"
                        size="sm"
                    />
                </div>
            </div>
            <div v-if="!items.length && !pausedItems.length && !isLoading" class="container" style="margin-top: 80px">
                <p class="info-text text-center">
                    {{ $t('moodPulse.emptyMessage') }}
                </p>
                <div class="row justify-content-center">
                    <div class="col-6">
                        <img class="mt-5 empty-image" src="@/assets/images/icon-enps.svg" style="margin-bottom: 60px" />
                    </div>
                </div>
            </div>
            <new-question-modal
                :show="showQuiz"
                @click="(show) => (showQuiz = show)"
                :refresh-items="updateItems"
                :itemToEdit="currentQuiz"
            />
            <delete-question-modal :show="showEndQuiz" :refresh-items="updateItems" :itemToEdit="currentQuiz" />
            <start-status-modal :show="showStartQuiz" @click="(show) => (showStartQuiz = show)" :quiz="selectedQuiz" />
            <pause-status-modal
                :show="showPauseQuiz"
                @click="(show) => (showPauseQuiz = show)"
                :update-status="() => changeQuizStatus(selectedItem, quizStatus.paused.id)"
            />
        </div>
    </div>
</template>

<script>
import { getQuizList, updateQuiz } from './api'
import { quizStatus } from './constants'
import Loader from '@/views/components/loader'
import notification, { success, danger } from '@/lib/notification'

notification.init()

import { NewQuestionModal, StartStatusModal, PauseStatusModal, DeleteQuestionModal } from './children'

export default {
    components: {
        NewQuestionModal,
        StartStatusModal,
        PauseStatusModal,
        Loader,
        DeleteQuestionModal,
    },
    data() {
        return {
            isLoading: false,
            showQuiz: false,
            showStartQuiz: false,
            showPauseQuiz: false,
            showEndQuiz: false,
            quizStatus,
            currentPage: 1,
            pageTotal: 1,
            selectedItem: {},
            items: [],
            pausedItems: [],
            selectedQuiz: null,
            fields: [
                { key: 'title', label: 'Nome da pesquisa' },
                { key: 'week', label: 'Dias da semana', class: 'text-center' },
                { key: 'status', label: 'Status', class: 'text-center' },
                { key: 'actions', label: 'Ações', class: 'text-center' },
                { key: 'edit', label: '', class: 'text-center' },
            ],
            pausedFields: [
                { key: 'title', label: 'Pausadas' },
                { key: 'weeks', label: '', class: 'text-center' },
                { key: 'status', label: '', class: 'text-center' },
                { key: 'actions', label: '', class: 'text-center' },
                { key: 'edit', label: '', class: 'text-center' },
            ],
            headerClass: {
                background: '#F9F9F9 !importa',
                color: '#6E6E6E',
                fontSize: '18px',
            },
            currentQuiz: null,
        }
    },
    methods: {
        toggleNewQuiz() {
            ;(this.showQuiz = true), (this.currentQuiz = null)
        },
        toggleDeleteQuiz() {
            console.log('entrou', this.showEndQuiz)
            ;(this.showEndQuiz = true), (this.currentQuiz = null)

            console.log('sai', this.showEndQuiz)
        },
        updateItems() {
            this.isLoading = true

            getQuizList(this.currentPage)
                .then((quizList) => {
                    this.pageTotal = quizList.total

                    if (quizList.data.length) {
                        this.items = quizList.data.filter((item) => item.quiz_status_id !== quizStatus.paused.id)

                        this.pausedItems = quizList.data.filter((item) => item.quiz_status_id === quizStatus.paused.id)
                        this.items = this.items.map((item) => ({
                            cardEditDelete: false,
                            ...item,
                        }))
                        this.pausedItems = this.pausedItems.map((item) => ({
                            cardEditDelete: false,
                            ...item,
                        }))
                    }
                })
                .finally(() => (this.isLoading = false))
        },
        changeQuizStatus(quiz, status) {
            quiz.quiz_status_id = status

            updateQuiz(quiz.id, quiz)
                .then(() => {
                    this.updateItems()

                    if (status === quizStatus.onGoing.id) {
                        this.selectedQuiz = quiz.id
                        this.showStartQuiz = true
                    }

                    if (status === quizStatus.paused.id) this.showPauseQuiz = false

                    success()
                })
                .catch(() => danger())
        },
    },
    mounted() {
        this.updateItems()
    },
}
</script>

<style scoped>
.title {
    font-family: Roboto;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 28px;
    color: #022b4f;
}

.text {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.002em;
    color: #3b3f4e;
}

.info-text {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    color: #3b3f4e;
}

.wrapper {
    width: 95vw !important;
    background-color: white !important;
    border: 1px solid #bec0c0 !important;
    box-sizing: border-box !important;
    border-radius: 5px !important;
    height: auto !important;
    padding-left: 0;
    padding-right: 0;
    margin-top: 20px;
    display: block !important;
}

.header {
    width: 100%;
    height: 140px;
    background: #f9f9f9;
    border-bottom: 1px solid #bec0c0;
    box-sizing: border-box;
    border-radius: 0px 5px 0px 0px;
    margin-left: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-right: 0 !important;
}

@media (max-height: 789px) {
    .empty-image {
        height: 243px;
        width: 373px;
        margin-left: 50px;
    }
}

@media (min-height: 790px) {
    .empty-image {
        height: 342px;
        width: 473px;
    }
}

.status-btn {
    width: 190px !important;
    height: 25px !important;
    border-radius: 4px !important;
    padding-top: 2px !important;
}

.action-btn {
    width: 77px !important;
    height: 34px !important;
    border-radius: 4px !important;
    font-size: 16px !important;
}

.body-class {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
    color: #6e6e6e !important;
    font-size: 16px !important;
    font-family: Roboto !important;
}
</style>
